import { useState } from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Scrollbar, A11y } from "swiper";

import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";

import {
  // Writers
  YellowBtn_174x47,
  PurpleBtn_219x47,
  PinkBtn_210x47,
  GreenBtn_174x47,
  PurpleBtn_192x47,
  CyanBtn_183x47,
  CyanBtn_228x47,
  PinkBtn_183x47,
  YellowBtn_255x47,
  GreenBtn_165x47,
  YellowBtn_273x47,
  PurpleBtn_183x47,
  PinkBtn_229x47,
  GreenBtn_201x47,
  CyanBtn_192x47,
  PurpleBtn_210x47,
  GreenBtn_309x47,
  YellowBtn_264x47,
  CyanBtn_210x47,
  PinkBtn_165x47,
  GreenBtn_183x47,
  CyanBtn_147x47,
  PurpleBtn_228x47,
  YellowBtn_228x47,
  YellowBtn_111x47,
  PurpleBtn_237x47,
  CyanBtn_156x47,
  PinkBtn_192x47,
  GreenBtn_120x47,
  CyanBtn_255x47,
  YellowBtn_219x47,
  PurpleBtn_165x47,
  PinkBtn_201x47,
  GreenBtn_192x47,
  YellowBtn_165x47,
  PurpleBtn_201x47,
  YellowBtn_210x47,
  GreenBtn_210x47,
  YellowBtn_192x47,
  GreenBtn_237x47,
  PinkBtn_174x47,
  GreenBtn_228x47,
  YellowBtn_183x47,
  GreenBtn_75x47,
  CyanBtn_165x47,
  YellowBtn_156x47,
  GreenBtn_219x47,
  CyanBtn_174x47,
  PinkBtn_219x47,
  YellowBtn_291x47,
  PurpleBtn_246x47,
  GreenBtn_246x47,
  CyanBtn_138x47,
  PurpleBtn_309x47,
  CyanBtn_237x47,
  PinkBtn_156x47,
  GreenBtn_273x47,
  CyanBtn_201x47,
  PurpleBtn_147x47,
  GreenBtn_255x47,
  PurpleBtn_174x47,
  PurpleBtn_255x47,
  GreenBtn_147x47,
  CyanBtn_219x47,
  PolygonRedFill_18x20,
  PolygonGreyOutline_18x20,
  SliderPrevGrey_24x24,
  SliderNextGrey_24x24,
  SliderSquareLeft_24x24,
  SliderSquareRight_24x24,
  // Graphic Designers
} from "@/utils/svg";
import CognisantButton from "@/common/components/button/CognisantButton";
import PossibiliyCard from "./PossibilityCard";
import { possibilityCards } from "@/utils/refUtils";

const possibilities = {
  fl_writers: [
    {
      name: "Grammar Checks",
      background: YellowBtn_174x47,
      bgStyle:
        "w-[120px] md:w-[144px] lg:w-[174px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Research Assistance",
      background: PurpleBtn_219x47,
      bgStyle:
        "w-[150px] md:w-[184px] lg:w-[219px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Sentiment Analysis",
      background: PinkBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Trend analysis",
      background: GreenBtn_174x47,
      bgStyle:
        "w-[120px] md:w-[144px] lg:w-[174px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Style Assistance",
      background: PurpleBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Idea Generation",
      background: CyanBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Content Optimisation",
      background: CyanBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Text Generation",
      background: PinkBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Automate Transcriptions",
      background: YellowBtn_255x47,
      bgStyle:
        "w-[174px] md:w-[216px] lg:w-[255px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Summarisation",
      background: GreenBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],

  fl_graphicdesigners: [
    {
      name: "Colour Scheme Suggestions",
      background: YellowBtn_273x47,
      bgStyle:
        "w-[186px] md:w-[232px] lg:w-[273px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Logo Generation",
      background: PurpleBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Design Research",
      background: CyanBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Typography Selection",
      background: PinkBtn_229x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[229px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "AI Illustrations",
      background: GreenBtn_201x47,
      bgStyle:
        "w-[136px] md:w-[168px] lg:w-[201px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Image Retouching",
      background: CyanBtn_192x47,
      bgStyle:
        "w-[130px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Content Generation",
      background: PurpleBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Automatic Template Generation",
      background: GreenBtn_309x47,
      bgStyle:
        "w-[210px] md:w-[264px] lg:w-[309px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Automated Design Feedback",
      background: YellowBtn_273x47,
      bgStyle:
        "w-[210px] md:w-[232px] lg:w-[255px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],

  fl_softwaredevelopers: [
    {
      name: "Code Comments Generation",
      background: YellowBtn_264x47,
      bgStyle:
        "w-[180px] md:w-[224px] lg:w-[264px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Automated Coding",
      background: PurpleBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Media Surveillance",
      background: CyanBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Bug Detection",
      background: PinkBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Chat automation",
      background: GreenBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Code Review",
      background: CyanBtn_147x47,
      bgStyle:
        "w-[102px] md:w-[120px] lg:w-[147px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Requirement Analysis",
      background: PurpleBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Software Maintenance",
      background: YellowBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Documentation",
      background: PinkBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],

  fl_tutors: [
    {
      name: "Grading",
      background: YellowBtn_111x47,
      bgStyle:
        "w-[78px] md:w-[88px] lg:w-[111px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Lesson Planning",
      background: GreenBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Personalised Learning",
      background: PurpleBtn_237x47,
      bgStyle:
        "w-[162px] md:w-[200px] lg:w-[237px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Research Aid",
      background: CyanBtn_156x47,
      bgStyle:
        "w-[108px] md:w-[128px] lg:w-[156px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Content Creation",
      background: PinkBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Feedback",
      background: GreenBtn_120x47,
      bgStyle:
        "w-[84px] md:w-[96px] lg:w-[120px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Knowledge Visualisation",
      background: CyanBtn_255x47,
      bgStyle:
        "w-[174px] md:w-[216px] lg:w-[255px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Resources Recommendation",
      background: YellowBtn_264x47,
      bgStyle:
        "w-[180px] md:w-[224px] lg:w-[264px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_dataanalysts: [
    {
      name: "Predictive Analysis",
      background: YellowBtn_219x47,
      bgStyle:
        "w-[150px] md:w-[184px] lg:w-[219px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Data Mining",
      background: CyanBtn_147x47,
      bgStyle:
        "w-[102px] md:w-[120px] lg:w-[147px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Data Cleaning",
      background: PurpleBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Anomaly Detection",
      background: PinkBtn_201x47,
      bgStyle:
        "w-[138px] md:w-[168px] lg:w-[201px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Data Integration",
      background: GreenBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Summarization",
      background: YellowBtn_165x47,
      bgStyle:
        "w-[126px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Time Series Analysis",
      background: CyanBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[212px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Report Generation",
      background: PurpleBtn_201x47,
      bgStyle:
        "w-[138px] md:w-[168px] lg:w-[201px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Data Visualization",
      background: YellowBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Content Generation",
      background: GreenBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_marketingspecialists: [
    {
      name: "Content Creation",
      background: YellowBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Social Media Analysis",
      background: GreenBtn_237x47,
      bgStyle:
        "w-[162px] md:w-[200px] lg:w-[237px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "News Briefing",
      background: PurpleBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Text Analytics",
      background: PinkBtn_174x47,
      bgStyle:
        "w-[120px] md:w-[144px] lg:w-[174px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Pricing Optimization",
      background: GreenBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Email Marketing",
      background: YellowBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Media Listening",
      background: CyanBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Narrative Tracking",
      background: PurpleBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Predictive Analytics",
      background: YellowBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "SEO",
      background: GreenBtn_75x47,
      bgStyle:
        "w-[54px] md:w-[56px] lg:w-[75px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_accountants: [
    {
      name: "Expense Tracking",
      background: YellowBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Invoice Processing",
      background: GreenBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Financial Forecasting",
      background: PurpleBtn_237x47,
      bgStyle:
        "w-[162px] md:w-[200px] lg:w-[237px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Payroll Management",
      background: GreenBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Audit Support",
      background: YellowBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Tax Preparation",
      background: CyanBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Budget Planning",
      background: PinkBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Real-Time Accounting",
      background: YellowBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_journalists: [
    {
      name: "Research Assistance",
      background: YellowBtn_219x47,
      bgStyle:
        "w-[150px] md:w-[184px] lg:w-[219px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Fact-Checking",
      background: GreenBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Automated Summaries",
      background: PurpleBtn_219x47,
      bgStyle:
        "w-[150px] md:w-[184px] lg:w-[219px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "creative writing",
      background: CyanBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Plagiarism Detection",
      background: GreenBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Trend spotting",
      background: YellowBtn_174x47,
      bgStyle:
        "w-[120px] md:w-[144px] lg:w-[174px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Data Analysis",
      background: CyanBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "News Aggregation",
      background: PinkBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Automated News Generation",
      background: YellowBtn_273x47,
      bgStyle:
        "w-[186px] md:w-[232px] lg:w-[273px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_traders: [
    {
      name: "Data Analysis",
      background: YellowBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Media Surveillance",
      background: GreenBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Algorithmic Trading",
      background: PurpleBtn_219x47,
      bgStyle:
        "w-[150px] md:w-[203px] lg:w-[219px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "News Briefing",
      background: CyanBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Predictive Modelling",
      background: GreenBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Event Prediction",
      background: YellowBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Data Analysis",
      background: CyanBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Research Platform",
      background: PinkBtn_201x47,
      bgStyle:
        "w-[138px] md:w-[168px] lg:w-[201px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Market Sentiment Analysis",
      background: YellowBtn_273x47,
      bgStyle:
        "w-[186px] md:w-[232px] lg:w-[273px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_seospecialists: [
    {
      name: "SEO Auditing",
      background: YellowBtn_156x47,
      bgStyle:
        "w-[108px] md:w-[128px] lg:w-[156px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Keyword Research",
      background: GreenBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Content Generation",
      background: PurpleBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[194px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Link Building",
      background: CyanBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Competitor Analysis",
      background: GreenBtn_219x47,
      bgStyle:
        "w-[150px] md:w-[184px] lg:w-[219px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Schema Markup",
      background: YellowBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Topic Modeling",
      background: CyanBtn_174x47,
      bgStyle:
        "w-[120px] md:w-[144px] lg:w-[174px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Meta Tag Generation",
      background: PinkBtn_219x47,
      bgStyle:
        "w-[150px] md:w-[184px] lg:w-[219px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Duplicate Content Detection",
      background: YellowBtn_291x47,
      bgStyle:
        "w-[198px] md:w-[248px] lg:w-[291px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_researchers: [
    {
      name: "Literature Review",
      background: YellowBtn_210x47,
      bgStyle:
        "w-[138px] md:w-[168px] lg:w-[201px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Data Analysis",
      background: GreenBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Research Summarization",
      background: PurpleBtn_246x47,
      bgStyle:
        "w-[168px] md:w-[230px] lg:w-[246px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Visualization",
      background: CyanBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Grant Proposal Writing",
      background: GreenBtn_246x47,
      bgStyle:
        "w-[168px] md:w-[208px] lg:w-[246px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Content Creation",
      background: YellowBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Scheduling",
      background: CyanBtn_138x47,
      bgStyle:
        "w-[96px] md:w-[112px] lg:w-[138px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Daily News Briefing",
      background: PinkBtn_219x47,
      bgStyle:
        "w-[150px] md:w-[184px] lg:w-[219px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Text Analytics",
      background: YellowBtn_174x47,
      bgStyle:
        "w-[120px] md:w-[144px] lg:w-[174px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_socialmediamanager: [
    {
      name: "Trend Identification",
      background: GreenBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Content Curation",
      background: PurpleBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[176px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Crisis Management",
      background: CyanBtn_210x47,
      bgStyle:
        "w-[138px] md:w-[168px] lg:w-[201px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Demographic Analysis",
      background: GreenBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Keyword Tracking",
      background: YellowBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Competition Analysis",
      background: CyanBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Content Generation",
      background: PinkBtn_210x47,
      bgStyle:
        "w-[142px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "autonomous account management",
      background: PurpleBtn_309x47,
      bgStyle:
        "w-[210px] md:w-[293px] lg:w-[309px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_virtualassistants: [
    {
      name: "Media Surveillance",
      background: YellowBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Text Generation",
      background: GreenBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Meeting Summarization",
      background: PurpleBtn_237x47,
      bgStyle:
        "w-[162px] md:w-[200px] lg:w-[237px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "News Briefings",
      background: CyanBtn_174x47,
      bgStyle:
        "w-[120px] md:w-[144px] lg:w-[174px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Email Management",
      background: PinkBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Document Creation",
      background: GreenBtn_201x47,
      bgStyle:
        "w-[138px] md:w-[168px] lg:w-[201px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Schedule Optimization",
      background: CyanBtn_237x47,
      bgStyle:
        "w-[162px] md:w-[200px] lg:w-[237px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Schedule Coordination",
      background: YellowBtn_273x47,
      bgStyle:
        "w-[162px] md:w-[200px] lg:w-[237px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_consultants: [
    {
      name: "Personalized Research",
      background: YellowBtn_273x47,
      bgStyle:
        "w-[162px] md:w-[200px] lg:w-[237px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Market Research",
      background: PurpleBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Predictive Modelling",
      background: PinkBtn_229x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[229px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Data Analysis",
      background: CyanBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Content Generation",
      background: GreenBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Customer Segmentation",
      background: CyanBtn_237x47,
      bgStyle:
        "w-[162px] md:w-[200px] lg:w-[237px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Competitive Analysis",
      background: YellowBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_translators: [
    {
      name: "Automated Transcription",
      background: YellowBtn_255x47,
      bgStyle:
        "w-[174px] md:w-[216px] lg:w-[255px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Summary Generation",
      background: PurpleBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Proofreading",
      background: PinkBtn_156x47,
      bgStyle:
        "w-[108px] md:w-[128px] lg:w-[156px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Language Style Adaptation",
      background: GreenBtn_273x47,
      bgStyle:
        "w-[186px] md:w-[232px] lg:w-[273px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Glossary Building",
      background: CyanBtn_201x47,
      bgStyle:
        "w-[138px] md:w-[168px] lg:w-[201px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Translation",
      background: PurpleBtn_147x47,
      bgStyle:
        "w-[102px] md:w-[120px] lg:w-[147px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Cultural Reference Handling",
      background: YellowBtn_291x47,
      bgStyle:
        "w-[198px] md:w-[248px] lg:w-[291px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_photographers: [
    {
      name: "Image Categorization",
      background: YellowBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Text generation",
      background: CyanBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Location Scouting",
      background: PurpleBtn_201x47,
      bgStyle:
        "w-[138px] md:w-[168px] lg:w-[201px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Image Synthesis",
      background: PinkBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Automatic Photo Editing",
      background: GreenBtn_255x47,
      bgStyle:
        "w-[174px] md:w-[216px] lg:w-[255px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Predictive Analytics",
      background: CyanBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[212px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Trend Research",
      background: YellowBtn_174x47,
      bgStyle:
        "w-[120px] md:w-[144px] lg:w-[174px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Copyright Protection",
      background: PurpleBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_lawyers: [
    {
      name: "Document Review",
      background: GreenBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Legal Research",
      background: PurpleBtn_174x47,
      bgStyle:
        "w-[120px] md:w-[158px] lg:w-[174px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Contract Analysis",
      background: CyanBtn_201x47,
      bgStyle:
        "w-[138px] md:w-[168px] lg:w-[201px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Due Diligence",
      background: GreenBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Drafting Documents",
      background: YellowBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Transcription",
      background: CyanBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Narrative Tracking",
      background: PinkBtn_210x47,
      bgStyle:
        "w-[142px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Legal Summaries",
      background: PurpleBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[167px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_prcomspecialists: [
    {
      name: "Draft Press Releases",
      background: GreenBtn_228x47,
      bgStyle:
        "w-[156px] md:w-[192px] lg:w-[228px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Media Monitoring",
      background: PinkBtn_192x47,
      bgStyle:
        "w-[130px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Crisis Detection",
      background: CyanBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[160px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Content Generation",
      background: PurpleBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Narrative Tracking",
      background: YellowBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Speech Writing",
      background: GreenBtn_174x47,
      bgStyle:
        "w-[120px] md:w-[144px] lg:w-[174px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Reputation Management",
      background: CyanBtn_237x47,
      bgStyle:
        "w-[162px] md:w-[200px] lg:w-[237px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Brand Voice Development",
      background: PurpleBtn_255x47,
      bgStyle:
        "w-[174px] md:w-[239px] lg:w-[255px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
  fl_entrepreneurs: [
    {
      name: "Business Analysis",
      background: GreenBtn_201x47,
      bgStyle:
        "w-[138px] md:w-[168px] lg:w-[201px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Personal Assistant",
      background: PinkBtn_210x47,
      bgStyle:
        "w-[142px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Content Creation",
      background: PurpleBtn_192x47,
      bgStyle:
        "w-[132px] md:w-[176px] lg:w-[192px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Financial Planning",
      background: CyanBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[176px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Recruitment",
      background: GreenBtn_147x47,
      bgStyle:
        "w-[102px] md:w-[120px] lg:w-[147px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Market Research",
      background: YellowBtn_183x47,
      bgStyle:
        "w-[126px] md:w-[152px] lg:w-[183px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Competitor Analysis",
      background: CyanBtn_219x47,
      bgStyle:
        "w-[150px] md:w-[184px] lg:w-[219px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "Data Visualization",
      background: PurpleBtn_210x47,
      bgStyle:
        "w-[144px] md:w-[194px] lg:w-[210px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
    {
      name: "News Briefing",
      background: YellowBtn_165x47,
      bgStyle:
        "w-[114px] md:w-[136px] lg:w-[165px] h-[33px] md:h-[39px] lg:h-[47px]",
    },
  ],
};

const Possibilities = ({ category }) => {
  const cardList = possibilityCards[category];
  const [sliderNumber, setSliderNumber] = useState(0);
  function prevSlider() {
    if (sliderNumber > 0) {
      setSliderNumber(sliderNumber - 1);
    }
  }
  function nextSlider() {
    if (sliderNumber < cardList.length - 1) {
      setSliderNumber(sliderNumber + 1);
    }
  }
  return (
    <div>
      <div className="flex flex-wrap gap-4 mr-0 lg:mr-4">
        {possibilities[category] &&
          possibilities[category].map((item, index) => (
            <CognisantButton
              key={index}
              bgImage={item.background}
              bgClass={item.bgStyle}
            >
              <span className="uppercase text-xs/[125%] md:text-base/[125%] lg:text-lg/[125%] font-bold">
                {item.name}
              </span>
            </CognisantButton>
          ))}
      </div>
      <div className="mt-14 -mr-4 md:-mr-[42px]">
        <Swiper
          modules={[Navigation, Scrollbar, A11y]}
          slidesPerView={"auto"}
          scrollbar={{ draggable: true }}
        >
          {cardList &&
            cardList.map((cardData, index) => (
              <SwiperSlide key={index} className="mr-4">
                <PossibiliyCard data={cardData} />
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
      <div className="flex justify-center gap-6 items-center mt-6 md:mt-[42px]">
        <Image
          src={SliderSquareLeft_24x24}
          alt="slider prev icon"
          className="cursor-pointer w-6 h-6"
          onClick={prevSlider}
        />
        <div className="flex items-center gap-1">
          {cardList &&
            cardList.map((item, index) => (
              <div key={index}>
                <Image
                  src={
                    sliderNumber === index
                      ? PolygonRedFill_18x20
                      : PolygonGreyOutline_18x20
                  }
                  alt="slider polygon icon"
                  className="cursor-pointer w-[10px] h-[10px]"
                  onClick={() => setSliderNumber(index)}
                />
              </div>
            ))}
        </div>
        <Image
          src={SliderSquareRight_24x24}
          alt="slider next icon"
          className="cursor-pointer w-6 h-6"
          onClick={nextSlider}
        />
      </div>
    </div>
  );
};

export default Possibilities;
